import { awaitableTemplate } from '../../../../webmodule-common/other/ui/template-processor';
import { customElement, property } from 'lit/decorators.js';
import { dashboard } from '../data/dashboard-cache';
import { DashboardWidget } from './dashboard-widget';
import { emptyGuid } from '../../../../webmodule-common/other/api/guid';
import { getApiFactory } from '../../../api/api-injector';
import { html } from 'lit';
import { moneyToTemplateResult } from '../../../../webmodule-common/other/currency-formatter';
import { PromiseSnippet } from '../../../../webmodule-common/interop/webmodule-interop';
import { QuoteState, ViewQuoteTotalByState } from '../../../api/dealer-api-interface-quote';
import { Snippet } from '../../../../webmodule-common/other/ui/events';
import { tlang } from '../../../../webmodule-common/other/language/lang';

@customElement('dashboard-branch-monthly-revenue-bystate')
export class BranchMonthlyRevenueByState extends DashboardWidget {
  api = getApiFactory().quote();
  @property() branchId? = emptyGuid;
  @property() assignedToUserId?: string;
  @property() state = 0;

  protected async getData(): Promise<ViewQuoteTotalByState[]> {
    const state = this.state;
    await dashboard().needsMonthlyQuoteFinancials(this.branchId);
    return dashboard().getMonthlyQuoteFinancials(state, this.assignedToUserId);
  }

  protected getHeader(): Snippet {
    return tlang`Monthly Generated Revenue ${QuoteState[this.state]}`;
  }
  protected getQuoteLabel(): Snippet {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    if (this.state >= QuoteState.Approved) return tlang`!!order!!`.toUpperCase();
    return tlang`!!quote!!`.toUpperCase();
  }

  protected getBody(): Snippet {
    return html`${awaitableTemplate(this.getTemplate(), 'Loading...')}`;
  }

  protected async getTemplate(): PromiseSnippet {
    const data = await this.getData();
    let quoteCount = 0;
    const total = data?.reduce((prev, x) => prev + x.total, 0) ?? 0;
    data?.forEach(x => (quoteCount += x.quoteCount));
    return html`
      <div class="card-subtitle text-secondary">${quoteCount} ${this.getQuoteLabel()}</div>
      <div class="display-5 text-primary">${moneyToTemplateResult(total)}</div>
    `;
  }
}
